import { useCallback, useEffect, useRef } from 'react';
import { useTimeout } from 'site-modules/shared/hooks/use-timeout';
import { randomInt } from 'client/utils/seed-randomizers';

const STREAM_EVENT = 'markdown-stream';

export function useMarkdownStream(bodyStream, { onData, onComplete }) {
  const batchIndex = useRef(0);
  const pushNextBatchRef = useRef();
  const [setNextBatchTimeout] = useTimeout();

  const pushNextBatch = useCallback(() => {
    if (!bodyStream || batchIndex.current >= bodyStream.length) {
      if (bodyStream) {
        onComplete();
      }
      return;
    }
    onData(STREAM_EVENT, { delta: bodyStream[batchIndex.current] });
    batchIndex.current += 1;

    setNextBatchTimeout(() => pushNextBatchRef.current?.(), (randomInt() % 60) + 100); // from 100ms to 160ms
  }, [bodyStream, onComplete, onData, setNextBatchTimeout]);

  useEffect(() => {
    pushNextBatchRef.current = pushNextBatch;
  }, [pushNextBatch]);

  useEffect(() => {
    setNextBatchTimeout(() => pushNextBatchRef.current?.(), 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
